import {HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {catchError, of} from "rxjs";
import {ToastService} from "../shared/commons/toast/toast-service";
import {inject} from "@angular/core";

export const IGNORE_LOADING = new HttpContextToken<boolean>(() => false);

export function http5xxInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const toastService: ToastService = inject(ToastService);
  if (req.context.get(IGNORE_LOADING)) {
    return next(req)
  }
  return next(req)
    .pipe(
      catchError(err => {
        console.log(err)
        console.log(err instanceof HttpErrorResponse)
        if (err instanceof HttpErrorResponse) {
          if (err.status >= 500 && err.status <= 505) {
            toastService.showDanger();
          } else if (err.status == 0) {
            toastService.showDanger();
          }
        } else if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          toastService.showDanger();
        }
        return of(err);
      })
    );
}
